import { Component, OnInit } from "@angular/core";
import { BsModalRef } from "ngx-bootstrap/modal";

@Component({
	selector: "app-modal-content-lite",
	template: `
		<div class="modal-header">
			<span [innerHTML]="htmlModalHeader | safeHtml"></span>
			<button
				type="button"
				class="close pull-right"
				aria-label="Close"
				(click)="bsModalRef.hide()"
			>
				<span aria-hidden="true">&times;</span>
			</button>
		</div>
		<div class="modal-body" [innerHTML]="htmlModalBody | safeHtml"></div>
		<div class="modal-footer" *ngIf="showFooter" [innerHTML]="htmlModalFooter | safeHtml">
			
		</div>
	`,
	styles: []
})
export class ModalContentLiteComponent implements OnInit {
  showFooter: boolean;
  htmlModalHeader: string;
  htmlModalBody: string;
  htmlModalFooter: string;
	constructor(public bsModalRef: BsModalRef) {}

	ngOnInit() {}
}
